import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "following-list-container"
}
const _hoisted_3 = {
  key: 0,
  class: "empty-followings"
}
const _hoisted_4 = {
  key: 1,
  class: "followings-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "user-details" }
const _hoisted_7 = { class: "username" }
const _hoisted_8 = {
  key: 0,
  class: "pagination-wrapper"
}

import { ref, computed, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getUserFollowings, getUserFollowers, followUser, unfollowUser } from '@/user/api/userApi';
import { useRouter } from 'vue-router';
import OtherUserProfileModal from '../user/OtherUserProfileModal.vue'; // 导入用户信息弹窗组件

interface Props {
  modelValue: boolean;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
  (e: 'report-user', payload: { targetType: number, targetId: number }): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FollowingListModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "close", "report-user"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 定义响应式变量
const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const router = useRouter();
const loading = ref(false);
const followings = ref<any[]>([]);
const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);
const showUserProfileModal = ref(false); // 控制用户信息弹窗显示
const selectedUserId = ref(0); // 当前选中的用户ID

// 移除旧的showUserProfile函数定义，使用下面这个
const showUserProfile = (userId: number) => {
  selectedUserId.value = userId;
  showUserProfileModal.value = true;
};


// 加载关注列表
const loadFollowings = async () => {
  try {
    loading.value = true;
    console.log('正在请求关注列表，参数:', { page: currentPage.value, pageSize: pageSize.value });
    
    const response = await getUserFollowings({
      page: currentPage.value,
      pageSize: pageSize.value
    });

    console.log('关注列表API响应:', response);
    
    // 检查API响应结构
    if ('total' in response.data && 'records' in response.data) {
      // 直接是分页数据结构
      followings.value = response.data.records || [];
      total.value = response.data.total || 0;
    } else {
      console.error('API返回错误格式:', response.data);
      throw new Error('获取关注列表失败');
    }
  } catch (error: any) {
    console.error('获取关注列表失败:', error);
    followings.value = [];
    total.value = 0;
  } finally {
    loading.value = false;
  }
};

// 分页改变
const handlePageChange = (page: number) => {
  currentPage.value = page;
  loadFollowings();
};

// 每页数量改变
const handleSizeChange = (size: number) => {
  pageSize.value = size;
  currentPage.value = 1;
  loadFollowings();
};

// 关闭对话框
const handleClose = () => {
  emit('close');
};

// 处理关闭用户资料弹窗
const handleCloseModal = () => {
  showUserProfileModal.value = false;
};


// 监听弹窗显示状态变化
watch(dialogVisible, (newValue) => {
  if (newValue) {
    currentPage.value = 1;
    loadFollowings();
  }
});

// 处理举报用户事件
const handleReportUser = (payload: { targetType: number, targetId: number }) => {
  // 将事件向上冒泡
  emit('report-user', payload);
};

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
    title: "我的关注",
    width: "600px",
    "close-on-click-modal": false,
    "before-close": handleClose,
    class: "warm-theme-dialog"
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_skeleton, {
              rows: 4,
              animated: ""
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (followings.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 暂无关注用户 "))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followings.value, (user) => {
                    return (_openBlock(), _createBlock(_component_el_card, {
                      key: user.id,
                      class: "following-item warm-card",
                      shadow: "never"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "user-info",
                          onClick: ($event: any) => (showUserProfile(user.id))
                        }, [
                          _createVNode(_component_el_avatar, {
                            size: 40,
                            src: user.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                            class: "warm-avatar"
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(user.name || '未知用户'), 1)
                          ])
                        ], 8, _hoisted_5)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (total.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_el_pagination, {
                          "current-page": currentPage.value,
                          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                          "page-size": pageSize.value,
                          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
                          total: total.value,
                          "page-sizes": [5, 10, 15, 20],
                          layout: "total, sizes, prev, pager, next, jumper",
                          class: "warm-pagination",
                          onCurrentChange: handlePageChange,
                          onSizeChange: handleSizeChange
                        }, null, 8, ["current-page", "page-size", "total"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])),
      _createVNode(OtherUserProfileModal, {
        modelValue: showUserProfileModal.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showUserProfileModal).value = $event)),
        userId: selectedUserId.value,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (showUserProfileModal.value = false)),
        onReportUser: handleReportUser
      }, null, 8, ["modelValue", "userId"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})